var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoeurvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.09 60.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:#2cb67d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m49.67.15c-1.03-.1-2-.15-2.9-.15-7.07,0-10.55,2.97-14.41,7.51.02,0,.04,0,.06,0-.06.03-.11.07-.16.11-.07.08-.14.16-.21.25-.07-.08-.14-.16-.21-.25-.05-.04-.1-.08-.16-.11.02,0,.04,0,.06,0C27.88,2.97,24.4,0,17.33,0c-.91,0-1.87.05-2.9.15C8.15.76.89,6.51,0,17.51v3.66c.82,10.52,8.76,23.49,31.94,39.75,0-.02.21-.03.2,0,23.18-16.26,31.12-29.23,31.94-39.75v-3.66C63.21,6.51,55.95.76,49.67.15Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2.69 32.5 19.19 32.5 22.19 26.5 24.19 39.5 27.19 28.5 30.19 32.5 35.19 32.5 39.19 14.5 42.19 46.5 47.19 27.5 48.19 32.5 60.69 32.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeurvert);
export default __webpack_public_path__ + "static/media/coeurvert.41b1bcc74f608f6117af49761cab6492.svg";
export { ForwardRef as ReactComponent };